import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesCloseBookBookmark: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.81 1.52h24.38v1.53h-1.52v1.52h1.52v3.05h1.53v22.86h1.52V6.1h-1.52V1.52h1.52V0H3.81z\"/><path fill=\"currentColor\" d=\"M6.86 30.48V7.62H16V6.1H3.81v1.52h1.53v22.86H3.81V32h25.91v-1.52z\"/><path fill=\"currentColor\" d=\"M25.15 10.67h-1.53V6.1H22.1V4.57h1.52V3.05H16v1.52h1.53V6.1h1.52v15.23h1.52v-1.52h1.53v-1.52h1.52v1.52h1.53v1.52h1.52V6.1h-1.52z\"/><path fill=\"currentColor\" d=\"M23.62 4.57h1.53V6.1h-1.53ZM5.34 3.05h9.14v1.52H5.34Zm-3.05 25.9h1.52v1.53H2.29Zm0-27.43h1.52v1.53H2.29Zm0 4.58h1.52V4.57H2.29V3.05H.76v25.9h1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesCloseBookBookmark
